var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfilePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 19,
    fill: "#E1E1E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 9C17.8213 9 16.6908 9.46825 15.8573 10.3017C15.0238 11.1352 14.5556 12.2657 14.5556 13.4444C14.5556 14.6232 15.0238 15.7536 15.8573 16.5871C16.6908 17.4206 17.8213 17.8889 19 17.8889C20.1788 17.8889 21.3092 17.4206 22.1427 16.5871C22.9762 15.7536 23.4445 14.6232 23.4445 13.4444C23.4445 12.2657 22.9762 11.1352 22.1427 10.3017C21.3092 9.46825 20.1788 9 19 9ZM15.9704 22.2339C15.6283 21.9109 15.1604 21.7204 14.7053 21.8401C11.8168 22.5996 9 24.0596 9 26.2222V27.8C9 28.4627 9.53726 29 10.2 29H27.8001C28.4628 29 29.0001 28.4627 29.0001 27.8V26.2222C29.0001 24.0596 26.1833 22.5996 23.2947 21.8401C22.8397 21.7204 22.3718 21.9109 22.0296 22.2339C21.2374 22.9818 20.1756 23.4444 19 23.4444C17.8244 23.4444 16.7626 22.9818 15.9704 22.2339Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePlaceholder);
export default __webpack_public_path__ + "static/media/ProfilePlaceholder.dc864849febc0bfed6eba8877dda86f6.svg";
export { ForwardRef as ReactComponent };